module.exports = __webpack_public_path__ + "static/media/play_button.b093f60f.svg";